import React from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./ReturnOrderDetail.module.scss";
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard";
import ColoredHeader from "../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const ReturnOrderDetail = ({ setShowReturnDetails }) => {
    const generalInfoData = [
        { label: "Order ID", value: "#1234" },
        { label: "Return ID", value: "#123" },
        { label: "Customer Name", value: "Full Name" },
        { label: "Customer Phone No.", value: "03417053723" },
        { label: "Order Total", value: "$50.00" },
        { label: "Payment Status", value: "Shipped" },
        { label: "Order Date", value: "October 4, 2024" },
        { label: "Return Request Date", value: "October 4, 2024" },
        { label: "Return Status", value: "Paid" },
        { label: "Seller Approval", value: "AS Store" },
        { label: "Seller Store name", value: "AS Store" },
    ];

    const shippingInfoData = [
        { label: "Shipping Address", value: "Al-Noor Garden Faisalabad, Faisalabad Pakistan" },
        { label: "Delivery Type", value: "Standard" },
        { label: "Shipping Status", value: "Shipped" },
        { label: "Courier Name", value: "DHL Express" },
        { label: "Tracking ID", value: "DHL12345678" },
        { label: "Estimated Delivery Date", value: "October 6, 2024" },
    ];

    const paymentInfoData = [
        { label: "Subtotal", value: "$49.00" },
        { label: "Shipping Fee", value: "+$1.00" },
        { label: "Discount", value: "-$0.00" },
        { label: "Total", value: "$50.00" },
        { label: "Payment Method", value: "Credit Card" },
        { label: "Status", value: "Paid" },
        { label: "Authorization Code", value: "AUTH12345678" },
        { label: "Transaction ID", value: "TXN235667" },
    ];

    const tableData = [
        {
            productName: "Product Name",
            productId: "#1234",
            sku: "SKU124a",
            qty: 1,
            price: "$49.00",
        },
    ];

    const columns = [
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            minWidth: "150px",
        },
        {
            name: "Product ID",
            selector: (row) => row.productId,
            center: "true",
            minWidth: "120px",
        },
        {
            name: "SKU",
            selector: (row) => row.sku,
            center: "true",
        },
        {
            name: "Qty",
            selector: (row) => row.qty,
            center: "true",
        },
        {
            name: "Unit Price",
            selector: (row) => row.price,
            center: "true",
            minWidth: "120px",
        },
    ];

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderDetailWrapper}>
                <ComponentBackButton onClick={() => setShowReturnDetails(false)} />
                <h4 className={styles.mainHeading}>Return Order Detail</h4>
                <Row className={styles.infoCardRow}>
                    <Col>
                        <InfoCard title="General Information" headerColor="#FBBD34" data={generalInfoData} />
                    </Col>
                    <Col>
                        <InfoCard title="Shipping Information" headerColor="#41B8E4" data={shippingInfoData} />
                    </Col>
                    <Col>
                        <InfoCard title="Payment Information" headerColor="#EC7426" data={paymentInfoData} />
                    </Col>
                </Row>
                <Row className={styles.dataTableRow}>
                    <Col xl={9}>
                        <div className={styles.dataTableWrapper}>
                            <ColoredHeader title={"Product"} headerColor={"#9747FF"} />
                            <DynamicDatatable
                                data={tableData}
                                columns={columns}
                                type="gray"
                                highlightOnHover
                            />
                        </div>
                    </Col>
                    <Col xl={3} className={styles.btnsWrapperColumn}>
                        <div className={styles.btnsContainer}>
                            <DynamicButton theme="sky-blue">Change Status</DynamicButton>
                            <DynamicButton theme="orange">Approve/Reject</DynamicButton>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ReturnOrderDetail;